/* Hızlı bakış: [data-quick-view="<ürün url>"] tıklanınca modal açılır, içerik Section Rendering API ile gelir */
(() => {
  if (window.CPLQuickView) return;
  const cache = new Map();
  let lastFromModal = false;

  const getModal = () => document.querySelector('[data-quick-view-modal]');

  async function load(url) {
    const base = url.split('?')[0];
    if (cache.has(base)) return cache.get(base);
    const res = await fetch(`${base}?section_id=quick-view-product`);
    if (!res.ok) throw new Error(res.status);
    const html = await res.text();
    cache.set(base, html);
    return html;
  }

  async function open(url, opener) {
    const modal = getModal();
    if (!modal) {
      window.location.href = url;
      return;
    }
    const content = modal.querySelector('[data-quick-view-content]');
    const panel = modal.querySelector('[role="dialog"]');
    const loading = modal.querySelector('template[data-quick-view-loading]');
    content.replaceChildren(loading ? loading.content.cloneNode(true) : '');
    modal.open(opener);

    try {
      const html = await load(url);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const product = doc.querySelector('quick-view-product');
      if (!product) throw new Error('empty');
      content.replaceChildren(product);
      const title = product.querySelector('[id^="QuickViewTitle"]');
      if (title) {
        panel.setAttribute('aria-labelledby', title.id);
        panel.removeAttribute('aria-label');
      }
      CPL.trapFocus(panel, panel);
    } catch (e) {
      const p = document.createElement('p');
      p.className = 'form-message form-message--error quick-view__error';
      p.textContent = modal.dataset.error || '';
      content.replaceChildren(p);
    }
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (!trigger) return;
    e.preventDefault();
    open(trigger.dataset.quickView, trigger);
  });

  /* Modal içinden sepete eklenince modalı kapat (çekmece/toast cart-drawer.js'te açılır) */
  document.addEventListener(
    'submit',
    (e) => {
      const modal = getModal();
      lastFromModal = !!(modal && modal.contains(e.target));
    },
    true
  );
  if (window.CPL && CPL.subscribe) {
    CPL.subscribe(CPL.events.cartUpdate, () => {
      const modal = getModal();
      if (lastFromModal && modal && !modal.hidden) modal.close();
      lastFromModal = false;
    });
  }

  window.CPLQuickView = { open };
})();

/* <quick-view-product> — galeri küçük resimleri ve "Sepete ekle · ₺toplam" etiketi */
if (!customElements.get('quick-view-product')) {
  class QuickViewProduct extends HTMLElement {
    connectedCallback() {
      this.submit = this.querySelector('[data-variant-submit]');
      this.qty = this.querySelector('input[name="quantity"]');
      this.price = Number(this.submit?.dataset.price || 0);
      this.available = !this.submit?.disabled;

      this.addEventListener('variant:change', (e) => {
        this.price = e.detail.price;
        this.available = e.detail.available;
        this.updateLabel();
      });
      this.qty?.addEventListener('change', () => this.updateLabel());
      this.qty?.addEventListener('input', () => this.updateLabel());

      this.querySelectorAll('[data-quick-view-thumb]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const img = this.querySelector('.quick-view__image');
          if (img && btn.dataset.image) {
            img.src = btn.dataset.image;
            img.srcset = btn.dataset.srcset || '';
          }
          this.querySelectorAll('[data-quick-view-thumb]').forEach((b) => b.setAttribute('aria-pressed', b === btn));
        })
      );
    }

    updateLabel() {
      const label = this.submit?.querySelector('[data-variant-submit-label]');
      if (!label || !this.available) return;
      const qty = Math.max(1, parseInt(this.qty?.value, 10) || 1);
      label.textContent = (this.dataset.labelTotal || '').replace('__PRICE__', CPL.formatMoney(this.price * qty));
    }
  }
  customElements.define('quick-view-product', QuickViewProduct);
}
